/* eslint-disable no-console */
import React, { Suspense, useContext, lazy } from 'react';

import {
  Routes,
  Route,
  BrowserRouter,
  Outlet,
  Navigate,
} from 'react-router-dom';
import { ALL_ROUTES } from 'config/routes';
import { redirectionURLs } from 'config/role';
import { authContext } from 'contexts/AuthContext';
import ProtectedRoute from 'components/ProtectedRoute';
import TaskReminderNotificationListener from 'components/TaskReminderNotificationListener';
import Loader from 'components/common/Loader';
import version from 'utils/version.json';
import Drawers from 'components/Drawers';

const Login = lazy(() => import('pages/Login'));
const Signup = lazy(() => import('pages/Signup'));
const ForgotPassword = lazy(() => import('pages/ForgotPassword'));
const AppVersion = lazy(() => import('components/AppVersion'));
const PageNotFound = lazy(() => import('pages/PageNotFound'));
const App = lazy(() => import('pages/App'));
const ResetPassword = lazy(
  () => import('pages/ForgotPassword/components/ResetPassword'),
);
const InvalidTab = lazy(() => import('components/SecurityFeatures/InvalidTab'));
const ResetPasswordSuccess = lazy(() => import('pages/ResetPasswordSuccess'));

const AppContainer = () => {
  console.info('App version: ', version);
  const { auth } = useContext(authContext);
  const userRoles = auth?.data?.roles;
  const userRole = userRoles?.[0].name;
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div
            className="d-flex justify-content-center align-items-center "
            style={{ height: '100vh' }}
          >
            <Loader />
          </div>
        }
      >
        <TaskReminderNotificationListener />
        <Drawers />
        <Routes>
          <Route element={<Outlet />}>
            {/* <Route path="/" component={<Login />} /> */}
            <Route path="/login" element={<Login />} />

            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/resetpassword" element={<ResetPassword />} />
            <Route
              path="/reset-password-success"
              element={<ResetPasswordSuccess />}
            />
            <Route path="/page-not-found" element={<PageNotFound />} />
            <Route path="/not-valid-tab" element={<InvalidTab />} />
            <Route path="/version" element={<AppVersion />} />

            <Route element={<App />}>
              {ALL_ROUTES.map((route, index) => {
                return (
                  <Route
                    key={String(index + 1)}
                    element={
                      <ProtectedRoute
                        requiredRoles={route.requiredRoles}
                        requiredPermissions={
                          route.requiredPermissions || route.permission
                        }
                        // key={String(index + 1)}
                      />
                    }
                  >
                    <Route path={route.path} element={route.component} />
                  </Route>
                );
              })}
              <Route
                path="/"
                element={
                  <Navigate
                    to={
                      redirectionURLs[userRole]
                        ? redirectionURLs[userRole]
                        : '/login'
                    }
                  />
                }
              />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppContainer;
